import React, { useEffect, useReducer, useRef } from 'react'
import { isTeamContextHandled } from '../../teamContext/teamSwitchService'
import { Popup } from '../../design_system/components/Popup/Popup.jsx'
import { Button, IconButton } from '../../design_system/components/Button/Button.jsx'
import { TabItem } from '../../design_system/components/Tabs/TabItem.jsx'
import { TabGroup } from '../../design_system/components/Tabs/TabGroup.jsx'
import ConditionalRender from '../../ConditionalRender'
import { SelectionControl } from '../../design_system/components/SelectionControls/SelectionControl.jsx'
import ContinueArrow from "../../assets/ContinueArrow.svg"
import { indexOfObject } from '../utils/ArrayUtils'
import { apiAgent } from '../../axiosConfig'
import getApiUrl from '../utils/UrlHelper'
import { Loader } from '../../design_system/components/Loader.jsx'
import Avatar from '../../design_system/components/Avatar/Avatar.jsx'
import { Link } from 'react-router-dom'
import { currentMonth, currentYear, getMonthName } from '../utils/dateUtils'
import { Icons } from '../../design_system/components/Icons'
import { Tooltip } from '../../design_system/components/ToolTip/ToolTip.jsx'
import { Badge } from '../../design_system/components/Input Fields/Badge.jsx'
import { DateFilter } from '../cta_utils/AnDateFilter'

const initialSelectedDate = { fromMonth: currentMonth, fromYear: currentYear, toMonth: currentMonth, toYear: currentYear }
const AddToCrmPopup = ({
    prospect,
    post,
    ...props
}) => {
    const [modalData, setModalData] = useReducer(reducer, {
        activeTab: post.saved_to_crm ? "li_exp_tab" : "approval_tab",
        matchedRelations: [],
        currentCrmRelations: [],
        currentLiExp: [],
        selectedRelations: [],
        primaryRelation: null,
        isLoading: {},
        dropDownList: {},
        selectedDate: { ...initialSelectedDate },
        matched_ids: [],
        fetchError: false
    })
    const { matchedRelations, activeTab, selectedRelations, currentCrmRelations, currentLiExp, isLoading, primaryRelation, dropDownList, selectedDate, matched_ids, fetchError } = modalData;
    const pencilRefs = useRef({});
    useEffect(() => {
        setModalData({
            type: "SET_STATE", payload: {
                isLoading: { fetchingData: true }
            }
        })
        apiAgent({
            method: "get",
            url: getApiUrl("get_crm_matched_relationships"),
            params: { prospect_id: prospect.id }
        }).then(res => {
            let matchedRel = [...res.data.matched_relations]
            let ids = []
            matchedRel.forEach((rel, index) => {
                rel.updated_start_month = parseInt(rel.start_month);
                rel.updated_start_year = parseInt(rel.start_year);
                rel.updated_end_month = parseInt(rel.end_month);
                rel.updated_end_year = parseInt(rel.end_year)
                if (rel.end_year || rel.end_month)
                    ids.push(rel.id)
            })
            setModalData({
                type: "SET_STATE", payload: {
                    matchedRelations: res.data.matched_relations,
                    currentCrmRelations: res.data.current_relations,
                    currentLiExp: res.data.ln_current_profs,
                    selectedRelations: [...res.data.matched_relations],
                    primaryRelation: res.data.matched_relations.filter(rel => rel.is_new)[0]?.id,
                    isLoading: {},
                    matched_ids: ids,
                    fetchError: false
                }
            })
        }).catch(err => {
            setModalData({
                type: "SET_STATE", payload: {
                    isLoading: {},
                    fetchError: true
                }
            })
        })
    }, [])

    const handleTickMarkChange = (rel) => {
        let index = indexOfObject(selectedRelations, "id", rel.id)
        let temp = [...selectedRelations]
        if (index === -1) {
            temp.push({ ...rel })
        } else {
            temp.splice(index, 1)
        }
        setModalData({ type: "SET_STATE", payload: { selectedRelations: temp } })
    }
    const handleOnApprove = () => {
        if (selectedRelations.length === 0) return
        let data_params = {
            prospect_id: prospect.id,
            post_id: post.id,
            // Be cautious with is_primary in backend. On edit is_primary should not change. Only change in new jobs
            relations: selectedRelations.map(sel_rel => ({
                id: sel_rel.id,
                position: sel_rel.position,
                company_name: sel_rel.company,
                start_year: sel_rel.updated_start_year,
                start_month: sel_rel.updated_start_month,
                end_year: sel_rel.updated_end_year,
                end_month: sel_rel.updated_end_month,
                new_job: sel_rel.is_new,
                company_id: sel_rel.company_id,
                industry: sel_rel.industry,
                is_primary: primaryRelation === sel_rel.id
            }))
        }

        setModalData({
            type: "SET_STATE", payload: {
                isLoading: { approvingData: true }
            }
        })
        apiAgent({
            method: "post",
            url: getApiUrl("post_crm_matched_relationships"),
            data: data_params
        }).then(res => {
            setModalData({
                type: "SET_STATE", payload: {
                    isLoading: {}
                }
            })
            // What if prospect is not present in crm ?
            if (res.data.success) {
                props.onFinish?.({ success_message: { message: "Post will be saved to CRM", messageTheme: "success" }, item: { ...post, saved_to_crm: true, saved_to_crm_by: res.data.saved_to_crm_by } })
                props.handleOnClosePopup()
            }
        }).catch(err => {
            setModalData({
                type: "SET_STATE", payload: {
                    isLoading: {}
                }
            })
            if (isTeamContextHandled(err)) return;
            props.onFinish?.({ success_message: { message: "Something went wrong", messageTheme: "warning" } })
            props.handleOnClosePopup()
        })
    }
    const add_relation = (sel_rel) => {
        setModalData({
            type: "SET_STATE", payload: {
                isLoading: { addRelation: true }
            }
        })
        let relation = { id: sel_rel.id, position: sel_rel.position, company_name: sel_rel.company, start_year: sel_rel.start_year, start_month: sel_rel.start_month, end_year: sel_rel.end_year, end_month: sel_rel.end_month, new_job: true, is_primary: false, industry: sel_rel.industry }
        let data_params = {
            prospect_id: prospect.id,
            post_id: post.id,
            // Be cautious with is_primary in backend. On edit is_primary should not change. Only change in new jobs
            ...relation
        }
        apiAgent({
            method: "post",
            url: getApiUrl("create_relation"),
            data: data_params
        }).then(res => {
            let current_li_exp = [...currentLiExp]
            if (res.data.success) {
                let index = indexOfObject(current_li_exp, "id", sel_rel.id)
                if (index !== -1)
                    current_li_exp[index].saved_to_crm = true
                setModalData({
                    type: "SET_STATE", payload: {
                        isLoading: {},
                        currentLiExp: current_li_exp
                    }
                })
            }
        }).catch(err => {
            setModalData({
                type: "SET_STATE", payload: {
                    isLoading: {}
                }
            })
        })
    }
    const markAsPrimary = (rel_id) => {
        setModalData({
            type: "SET_STATE", payload: {
                primaryRelation: rel_id
            }
        })
    }
    const getJobDateString = (month, year, fallbackRes = "") => {
        let res = "";
        if (!month && !year) return fallbackRes
        if (month) res = getMonthName(month) + " ";
        if (year) res += year;
        return res
    }
    const handleOnFilterSaveCallback = (id) => {
        let matched_relations = [...matchedRelations]
        let index = indexOfObject(matched_relations, "id", id)
        if (index !== -1) {
            matched_relations[index].updated_start_month = parseInt(selectedDate.fromMonth);
            matched_relations[index].updated_start_year = parseInt(selectedDate.fromYear);
            matched_relations[index].updated_end_month = parseInt(selectedDate.toMonth);
            matched_relations[index].updated_end_year = parseInt(selectedDate.toYear)
        }
        setModalData({ type: 'SET_STATE', payload: { dropDownList: { [id]: false }, matchedRelations: matched_relations } })
    }
    const handleEditPencil = (rel) => {
        let selected_date = { ...selectedDate }
        selected_date.fromMonth = rel.updated_start_month
        selected_date.fromYear = rel.updated_start_year
        selected_date.toMonth = rel.updated_end_month
        selected_date.toYear = rel.updated_end_year
        setModalData({ type: 'SET_STATE', payload: { dropDownList: { [rel.id]: true }, selectedDate: selected_date } })
    }
    const handleOnCloseDropdown = () => {
        setModalData({ type: 'SET_STATE', payload: { dropDownList: {}, selectedDate: { ...initialSelectedDate } } })
    }
    const renderSavedReceipt = () => {
        return (
            <div className="crm-popup__receipt">
                <div className="flex items-center justify-center mb-m">
                    <Icons name="saved-to-crm" size={32} />
                </div>
                <div className="body-l-bold color-text-primary mb-xs">Saved to CRM</div>
                <ConditionalRender if={!!post.saved_to_crm_by}>
                    <div className="body-s-semibold color-text-secondary">
                        by <span className="body-s-bold">{post.saved_to_crm_by}</span>
                    </div>
                </ConditionalRender>
            </div>
        )
    }
    const renderMatchedRelations = () => {
        if (fetchError) {
            return (
                <div className="crm-popup__empty-state mt-m">
                    <div className='body-m-semibold crm-popup__empty-text'>Couldn't load CRM data. Please try again.</div>
                </div>
            )
        }
        const hasEndJobs = matchedRelations.some(rel => !rel.is_new);
        const hasComparableData = currentCrmRelations.length > 0 || currentLiExp.length > 0;
        return (
            <div>
                <ConditionalRender if={matchedRelations.length > 0}>
                    <div className="crm-popup__approval-content mt-m">
                        <ConditionalRender if={matchedRelations.filter(rel => !rel.is_new).length !== 0}>
                            <div className="crm-popup__end-jobs-section mt-m mb-m">
                                <div className='body-s-semibold crm-popup__section-label mb-s'>End current job{matchedRelations.filter(rel => !rel.is_new).length > 1 ? "s" : ""}</div>
                                <div className="crm-popup__table">
                                    {/* Header row */}
                                    <div className="flex items-center crm-popup__table-header px-m py-s">
                                        <div className="flex-shrink-0 crm-popup__table-checkbox-spacer" />
                                        <div className='body-s-semibold flex-1 crm-popup__table-cell'>CRM data</div>
                                        <div className="crm-popup__table-arrow">
                                            <img src={ContinueArrow} alt="->" />
                                        </div>
                                        <div className='body-s-semibold flex-1 crm-popup__table-cell'>Changing to</div>
                                    </div>
                                    {/* Data rows */}
                                    {matchedRelations.filter(rel => !rel.is_new).map((rel, index, arr) => {
                                        let is_checked = indexOfObject(selectedRelations, "id", rel.id) !== -1
                                        let isLast = index === arr.length - 1
                                        return (
                                            <div key={rel.id + index} className="flex items-start crm-popup__table-row p-m" style={{ borderBottom: isLast ? 'none' : "var(--border-width-s) solid var(--color-border-default)" }}>
                                                <div className="flex-shrink-0 crm-popup__row-checkbox mt-xs mr-s">
                                                    <SelectionControl
                                                        type="checkbox"
                                                        label=""
                                                        checked={is_checked}
                                                        onChange={() => handleTickMarkChange(rel)}
                                                    />
                                                </div>
                                                {/* Left cell — CRM data */}
                                                <div className="flex-1 crm-popup__table-cell">
                                                    <div className='body-s-semibold color-text-primary'>{rel.old_position}, {rel.company}</div>
                                                    <div className='support-m color-text-secondary mt-xs'>{getJobDateString(rel.start_month, rel.start_year)} - present</div>
                                                </div>
                                                {/* Arrow */}
                                                <div className="crm-popup__table-arrow">
                                                    <img src={ContinueArrow} alt="->" />
                                                </div>
                                                {/* Right cell — Changing to */}
                                                <div className="flex-1 crm-popup__table-cell">
                                                    <div className='body-s-semibold color-text-primary'>{rel.new_position}, {rel.company}</div>
                                                    <div className="flex items-center gap-xs crm-popup__date-row mt-xs">
                                                        <div className='support-m'>{getJobDateString(rel.updated_start_month, rel.updated_start_year)} - {getJobDateString(rel.updated_end_month, rel.updated_end_year, "present")}</div>
                                                        <div className="relative crm-popup__pencil-wrap" ref={el => pencilRefs.current[rel.id] = el}>
                                                            <IconButton Size="ExtraSmall" Type="Tertiary" IconName="pencil" ShowHover={false} ariaLabel="Edit date" onClick={() => handleEditPencil(rel)} />
                                                            {dropDownList?.[rel.id] && <DateFilter
                                                                selectedDate={selectedDate}
                                                                curr_rel_id={rel.id}
                                                                setSelectedDate={(selected_date) => setModalData({ type: 'SET_STATE', payload: { selectedDate: selected_date } })}
                                                                handleOnFilterSave={(id) => handleOnFilterSaveCallback(id)}
                                                                handleOnClose={() => handleOnCloseDropdown()}
                                                                usePortal={true}
                                                                triggerRef={{ current: pencilRefs.current[rel.id] }} />}
                                                        </div>
                                                    </div>
                                                    <Badge customClassName="label-s" customStyle={{ marginTop: "var(--space-xs)" }} type={matched_ids.includes(rel.id) ? "Success" : "Error"} label={matched_ids.includes(rel.id) ? "Matched" : "Not Matched"} />
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        </ConditionalRender>

                        <ConditionalRender if={matchedRelations.filter(rel => rel.is_new).length > 0}>
                            <div className={`crm-popup__new-jobs-section pb-m ${hasEndJobs ? "pt-m" : ""}`}>
                                <div className="flex items-center gap-s crm-popup__section-header mb-m">
                                    <span className='body-s-semibold whitespace-nowrap crm-popup__section-title'>Add new job{matchedRelations.filter(rel => rel.is_new).length > 1 ? "s" : ""}</span>
                                    <ConditionalRender if={matchedRelations.filter(rel => !rel.is_new).length > 0}>
                                        <div className="flex-1 crm-popup__section-divider" />
                                    </ConditionalRender>
                                </div>
                                {matchedRelations.filter(rel => rel.is_new).map((rel, index) => {
                                    let is_checked = indexOfObject(selectedRelations, "id", rel.id) !== -1
                                    return (
                                        <div key={rel.id + index} className="flex items-center crm-popup__new-job-row mb-s">
                                            <div className="w-full crm-popup__new-job-card p-m" style={{ background: is_checked ? "var(--color-feedback-success-surface)" : "var(--color-surface-subtle)" }}>
                                                <div className="flex flex-row crm-popup__new-job-card-inner">
                                                    <div className="flex-shrink-0 crm-popup__row-checkbox mr-s mt-xs">
                                                        <SelectionControl
                                                            type="checkbox"
                                                            label=""
                                                            checked={is_checked}
                                                            onChange={() => handleTickMarkChange(rel)}
                                                        />
                                                    </div>
                                                    <div>
                                                        <div className='body-s-semibold color-text-primary'>{rel.position}, {rel.company}</div>
                                                        <div className='support-m color-text-secondary mt-xs'>{getJobDateString(rel.start_month, rel.start_year)} - {getJobDateString(rel.end_month, rel.end_year, "present")}</div>
                                                        <ConditionalRender if={is_checked}>
                                                            <SelectionControl
                                                                key={rel.id}
                                                                type="radio"
                                                                label="Primary employment"
                                                                checked={primaryRelation === rel.id}
                                                                onChange={() => markAsPrimary(rel.id)}
                                                                className="mt-xs"
                                                            />
                                                        </ConditionalRender>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        </ConditionalRender>
                    </div>
                </ConditionalRender>
                <ConditionalRender if={matchedRelations.length === 0}>
                    {hasComparableData ? (
                        <div className="crm-popup__receipt">
                            <div className="flex items-center justify-center mb-m">
                                <Icons name="saved-to-crm" size={32} />
                            </div>
                            <div className="body-l-bold color-text-primary mb-xs">CRM data is up-to-date</div>
                        </div>
                    ) : (
                        <div className="crm-popup__empty-state mt-m">
                            <div className='body-m-semibold crm-popup__empty-text'>No data found</div>
                        </div>
                    )}
                </ConditionalRender>
            </div>
        )
    }

    const renderCRMExp = () => {
        if (currentCrmRelations.length === 0)
            return (
                <div className="crm-popup__empty-state">
                    <div className='body-m-semibold crm-popup__empty-text'>No data found</div>
                </div>
            )
        return (
            <div className="crm-popup__exp-list mb-l">
                <div className="body-s-semibold color-text-secondary mt-m">{currentCrmRelations.length} experiences in CRM</div>
                {currentCrmRelations.map((crm_rel, index) => {
                    return (
                        <div key={crm_rel.id + index} className="flex items-center gap-s">
                            <div className="crm-popup__exp-card w-full mt-s">
                                <div className="flex items-center w-full crm-popup__exp-card-body p-m">
                                    <div className="flex flex-col gap-xs w-full">
                                        <div className='body-m-semibold color-text-primary'>{[crm_rel.position, crm_rel.company].join(", ")}</div>
                                        <div className="support-m color-text-secondary mt-xs">{getJobDateString(crm_rel.start_month, crm_rel.start_year)} - {getJobDateString(crm_rel.end_month, crm_rel.end_year, "present")}</div>
                                    </div>
                                </div>
                            </div>
                        </div>)
                })}
            </div>
        )
    }
    const renderLinkedinExp = () => {
        if (currentLiExp.length === 0)
            return (
                <div className="crm-popup__empty-state">
                    <div className='body-m-semibold crm-popup__empty-text'>No data found</div>
                </div>
            )
        return (
            <div className="crm-popup__exp-list mb-l">
                <div className="body-s-semibold color-text-secondary mt-m">{currentLiExp.length} experiences in LinkedIn</div>
                {currentLiExp.map((li_rel, index) => {
                    let is_matched = matchedRelations.some(rel => rel.prof_id === li_rel.id || rel.id === li_rel.id);
                    return (
                        <div key={li_rel.id + index}>
                            <div className="crm-popup__exp-card mt-s">
                                <div className="flex items-center w-full crm-popup__exp-card-body p-m gap-xl">
                                    <div className="flex flex-col gap-xs w-full">
                                        <div className='body-m-semibold color-text-primary'>{[li_rel.position, li_rel.company].join(", ")}</div>
                                        <div className="support-m color-text-secondary mt-xs">{getJobDateString(li_rel.start_month, li_rel.start_year)} - {getJobDateString(li_rel.end_month, li_rel.end_year, "present")}</div>
                                    </div>
                                    <ConditionalRender if={!is_matched}>
                                        <div>{li_rel.saved_to_crm ?
                                            <span className='flex items-center body-s-bold crm-popup__added-label'>
                                                <Icons name="check" size={20} style={{ color: "var(--color-icon-brand)" }} />
                                                Added
                                            </span>
                                            :
                                            (<div className="relative crm-popup__add-btn-wrap">
                                                <Button Type="Primary" innerButtonStyle={{ padding: "var(--space-xs) var(--space-m)", width: "max-content" }} onClick={() => setModalData({ type: 'SET_STATE', payload: { dropDownList: { [li_rel.id]: true } } })}>Add</Button>
                                                {dropDownList?.[li_rel.id] &&
                                                    <div className="crm-popup__confirm-dropdown p-m mt-2xs">
                                                        <div className="body-m-semibold crm-popup__confirm-text mb-s">Are you sure you want to add this to your CRM?</div>
                                                        <div className="flex gap-s crm-popup__confirm-actions mt-s">
                                                            <Button onClick={() => add_relation(li_rel)} isLoading={isLoading.addRelation}>Yes</Button>
                                                            <Button Type="Secondary" onClick={() => handleOnCloseDropdown()}>Cancel</Button>
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                            )
                                        }
                                        </div>
                                    </ConditionalRender>
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>
        )
    }

    if (isLoading.fetchingData) {
        return (
            <Popup maxWidth={620} handleOnClosePopup={props.handleOnClosePopup}>
                <div className="crm-popup__loader-wrap">
                    <Loader isLoading={true} Size="Large" />
                </div>
            </Popup>
        )
    }

    const pendingJobsCount = selectedRelations.filter(rel => !rel.is_new).length;
    const addingJobCount = selectedRelations.filter(rel => rel.is_new).length;
    const extraAction = () => {
        if (activeTab === "approval_tab") {
            if (post.saved_to_crm) return null
            return { label: `${pendingJobsCount} jobs ending · ${addingJobCount} job adding`, onClick: () => { }, className: "body-s-semibold", style: { color: 'var(--color-text-tertiary)', cursor: 'default', textDecoration: 'none' } }
        }
        if (activeTab === "crm_exp_tab") {
            return { label: "Synced from your CRM", onClick: () => { }, className: "body-s-semibold", style: { color: 'var(--color-text-tertiary)', cursor: 'default', textDecoration: 'none' } }
        }
        if (activeTab === "li_exp_tab") {
            return { label: "Fetched from Linkedin profile", onClick: () => { }, className: "body-s-semibold", style: { color: 'var(--color-text-tertiary)', cursor: 'default', textDecoration: 'none' } }
        }
        return null
    }

    const primaryAction = () => {
        if (activeTab === "approval_tab" && !post.saved_to_crm && selectedRelations.length > 0) {
            return { label: "Approve", onClick: handleOnApprove, isLoading: isLoading.approvingData }
        }
        return null
    }

    const secondaryAction = () => {
        if (activeTab === "approval_tab" && !post.saved_to_crm) {
            return { label: "Cancel", onClick: props.handleOnClosePopup }
        }
        return null
    }

    return (
        <Popup
            name="Save job update to CRM"
            maxWidth={620}
            handleOnClosePopup={props.handleOnClosePopup}
            showHeaderDivider={false}
            customContentStyle={{ padding: 0, display: 'flex', flexDirection: 'column', maxHeight: 'calc(100vh - 200px)', overflow: 'hidden' }}
            extraAction={extraAction()}
            primaryAction={primaryAction()}
            secondaryAction={secondaryAction()}
            extraActionClassName="body-s-semibold"
        >
            <div className='flex w-full items-start crm-popup__prospect-block px-xl mb-m'>
                <Avatar name={prospect.name || prospect.designation} width={40} profile_image={prospect.profile_image} />
                <div className="flex-1 min-w-0 crm-popup__prospect-sub-block ml-l">
                    <div className="flex items-center">
                        <div className="min-w-0 overflow-hidden crm-popup__name-tooltip-wrap">
                            <Tooltip tooltipText={prospect.name || prospect.designation} enableTooltip placement="top-start">
                                <Link to={`/prospects/${prospect.id}`} target="_blank" className="body-m-bold color-text-primary truncate block no-underline">
                                    {prospect.name || prospect.designation}
                                </Link>
                            </Tooltip>
                        </div>
                        <ConditionalRender if={prospect.linkedin_url}>
                            <a href={prospect.linkedin_url} target="_blank" rel="noopener noreferrer" className="flex crm-popup__linkedin-link ml-xs">
                                <Icons name="linkedin" size={16} />
                            </a>
                        </ConditionalRender>
                    </div>
                    <ConditionalRender if={prospect.name}>
                        <Tooltip tooltipText={prospect.designation} enableTooltip placement="top-start">
                            <div className="body-s-semibold truncate color-text-secondary">
                                {prospect.designation}
                            </div>
                        </Tooltip>
                    </ConditionalRender>
                </div>
            </div>
            <TabGroup variant="line" fullWidth style={{ padding: "0 var(--space-xl)" }}>
                <TabItem label="Approve Employment Changes" isActive={activeTab === "approval_tab"} onClick={() => { setModalData({ type: "SWITCH_TAB", payload: "approval_tab" }) }} />
                <TabItem label="CRM Experiences" isActive={activeTab === "crm_exp_tab"} onClick={() => { setModalData({ type: "SWITCH_TAB", payload: "crm_exp_tab" }) }} />
                <TabItem label="LinkedIn Experiences" isActive={activeTab === "li_exp_tab"} onClick={() => { setModalData({ type: "SWITCH_TAB", payload: "li_exp_tab" }) }} />
            </TabGroup>
            <div className="flex-1 min-h-0 scroll-y crm-popup__tab-content px-xl">
                <ConditionalRender if={activeTab === "approval_tab"}>
                    {post.saved_to_crm ? renderSavedReceipt() : renderMatchedRelations()}
                </ConditionalRender>
                <ConditionalRender if={activeTab === "crm_exp_tab"}>{renderCRMExp()}</ConditionalRender>
                <ConditionalRender if={activeTab === "li_exp_tab"}>{renderLinkedinExp()}</ConditionalRender>
            </div>
        </Popup>
    )
}

export default AddToCrmPopup

const reducer = (state, action) => {
    switch (action.type) {
        case "SET_STATE": {
            return { ...state, ...action.payload }
        }
        case "SWITCH_TAB": {
            return { ...state, activeTab: action.payload }
        }
        default: return state
    }
}
